module.exports = __webpack_public_path__ + "04ebc25dd10fc1a15e38a2c006d75e79.svg";